<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="editAccessRights"
>
  <div class="mb-3" id="discovery-area-settings">
    <div formArrayName="configs">
      <ng-container *ngFor="let config of configs.controls; let i = index">
        <section
          *ngIf="isConfigVisible(config)"
          class="card mb-3"
          [formGroupName]="i"
          [attr.aria-labelledby]="'discovery-area-title-' + i"
        >
          <div class="card-header card-collapse">
            <h2 class="accordion-header">
              <button
                class="accordion-button flex-grow-1 d-flex align-items-center"
                type="button"
                [attr.aria-expanded]="configCollapsed[i] ? 'false' : 'true'"
                (click)="configCollapsed[i] = !configCollapsed[i]"
                [attr.aria-controls]="'discovery-area-config-' + i"
              >
                <span
                  class="fs-3 flex-grow-1"
                  [id]="'discovery-area-title-' + i"
                >
                  {{
                    getConfigTypeLabel(config.get('type')?.value) | translate
                  }}
                </span>

                <i
                  class="fa fa-fw ms-auto"
                  [ngClass]="
                    configCollapsed[i] ? 'fa-chevron-down' : 'fa-chevron-up'
                  "
                  aria-hidden="true"
                  role="img"
                ></i>
              </button>
            </h2>
            <button
              type="button"
              class="btn btn-ghost-secondary ms-3"
              (click)="removeConfig(i)"
              [canSee]="editAccessRights"
              [attr.aria-label]="'general.delete' | translate"
            >
              <i class="fa fa-trash-alt" aria-hidden="true" role="img"></i>
            </button>
          </div>

          <div
            *ngIf="!configCollapsed[i]"
            class="card-body"
            [attr.id]="'discovery-area-config-' + i"
          >
            <div class="row">
              <div class="col-lg-4 mb-3">
                <label class="form-label" [attr.for]="'config-type-' + i">{{
                  'general.type' | translate
                }}</label>
                <select
                  class="form-select"
                  formControlName="type"
                  [attr.id]="'config-type-' + i"
                >
                  <option [ngValue]="null">
                    {{ 'general.select' | translate }}
                  </option>
                  <option
                    *ngFor="let option of getConfigTypeOptions(i)"
                    [ngValue]="option.value"
                    [disabled]="option.disabled"
                  >
                    {{ option.label | translate }}
                  </option>
                </select>
              </div>
            </div>

            <language-inputs [formGroup]="config"></language-inputs>

            <div class="mt-3 mb-4">
              <h3>
                {{ 'configurationOptionModule.upliftedAreaSets' | translate }}
              </h3>
              <div formArrayName="upliftedAreaSets">
                <ng-container
                  *ngFor="
                    let areaSet of getUpliftedAreaSets(i).controls;
                    let j = index
                  "
                >
                  <div class="card mb-3 discovery-panel" [formGroupName]="j">
                    <div
                      class="card-header discovery-panel-header d-flex align-items-center justify-content-between"
                      [class.is-collapsed]="upliftedAreaCollapsed[i][j]"
                    >
                      <h4 class="accordion-header">
                        <button
                          type="button"
                          class="accordion-button"
                          [attr.aria-expanded]="
                            upliftedAreaCollapsed[i][j] ? 'false' : 'true'
                          "
                          (click)="
                            upliftedAreaCollapsed[i][j] =
                              !upliftedAreaCollapsed[i][j]
                          "
                          [attr.aria-controls]="
                            'uplifted-area-set-' + i + '-' + j
                          "
                        >
                          <span
                            class="d-flex flex-column align-items-start flex-grow-1"
                          >
                            <span
                              class="fs-4"
                              *ngIf="areaSet.get('title_en')?.value"
                            >
                              {{ areaSet.get('title_en')?.value }}
                            </span>
                            <span class="text-small text-body">
                              {{
                                'configurationOptionModule.upliftedAreaSet'
                                  | translate
                              }}
                              #{{ j + 1 }}
                            </span>
                          </span>
                          <i
                            class="fa fa-fw ms-auto"
                            [ngClass]="
                              upliftedAreaCollapsed[i][j]
                                ? 'fa-chevron-down'
                                : 'fa-chevron-up'
                            "
                            aria-hidden="true"
                            role="img"
                          ></i>
                        </button>
                      </h4>
                      <button
                        type="button"
                        class="btn btn-ghost-secondary ms-2"
                        (click)="removeUpliftedAreaSet(i, j)"
                        [canSee]="editAccessRights"
                        [attr.aria-label]="'general.delete' | translate"
                      >
                        <i
                          class="fa fa-trash-alt"
                          aria-hidden="true"
                          role="img"
                        ></i>
                      </button>
                    </div>

                    <div
                      class="card-body discovery-panel-body"
                      *ngIf="!upliftedAreaCollapsed[i][j]"
                      [attr.id]="'uplifted-area-set-' + i + '-' + j"
                    >
                      <language-inputs [formGroup]="areaSet"></language-inputs>

                      <div class="mt-3 mb-3" formArrayName="items">
                        <ng-container
                          *ngFor="
                            let item of getUpliftedItems(i, j).controls;
                            let k = index
                          "
                        >
                          <div
                            class="card mb-3 discovery-subpanel"
                            [formGroupName]="k"
                          >
                            <div
                              class="card-header discovery-subpanel-header d-flex align-items-center justify-content-between"
                              [class.is-collapsed]="
                                upliftedItemCollapsed[i][j][k]
                              "
                            >
                              <h5 class="accordion-header">
                                <button
                                  type="button"
                                  class="accordion-button"
                                  [attr.aria-expanded]="
                                    upliftedItemCollapsed[i][j][k]
                                      ? 'false'
                                      : 'true'
                                  "
                                  (click)="
                                    upliftedItemCollapsed[i][j][k] =
                                      !upliftedItemCollapsed[i][j][k]
                                  "
                                  [attr.aria-controls]="
                                    'uplifted-item-' + i + '-' + j + '-' + k
                                  "
                                >
                                  <span class="fs-5 flex-grow-0">
                                    {{
                                      'configurationOptionModule.upliftedItem'
                                        | translate
                                    }}
                                    #{{ k + 1 }}
                                  </span>
                                  <span class="ms-2 text-body flex-grow-1">
                                    —
                                    {{
                                      item.get('type')?.value === itemTypes.LINK
                                        ? ('configurationOptionModule.discoveryItemTypeLink'
                                          | translate)
                                        : ('configurationOptionModule.discoveryItemTypeTag'
                                          | translate)
                                    }}
                                  </span>
                                  <i
                                    class="fa fa-fw ms-auto"
                                    [ngClass]="
                                      upliftedItemCollapsed[i][j][k]
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                    "
                                    aria-hidden="true"
                                    role="img"
                                  ></i>
                                </button>
                              </h5>
                              <button
                                type="button"
                                class="btn btn-ghost-secondary ms-2"
                                (click)="removeUpliftedItem(i, j, k)"
                                [canSee]="editAccessRights"
                                [attr.aria-label]="'general.delete' | translate"
                              >
                                <i
                                  class="fa fa-trash-alt"
                                  aria-hidden="true"
                                  role="img"
                                ></i>
                              </button>
                            </div>

                            <div
                              class="card-body discovery-subpanel-body"
                              *ngIf="!upliftedItemCollapsed[i][j][k]"
                              [attr.id]="
                                'uplifted-item-' + i + '-' + j + '-' + k
                              "
                            >
                              <div class="row">
                                <div class="col-lg-6">
                                  <div class="mb-4">
                                    <label
                                      class="form-label"
                                      [attr.for]="
                                        'uplifted-item-type-' +
                                        i +
                                        '-' +
                                        j +
                                        '-' +
                                        k
                                      "
                                      >{{
                                        'configurationOptionModule.itemType'
                                          | translate
                                      }}</label
                                    >
                                    <select
                                      class="form-select"
                                      formControlName="type"
                                      [attr.id]="
                                        'uplifted-item-type-' +
                                        i +
                                        '-' +
                                        j +
                                        '-' +
                                        k
                                      "
                                    >
                                      <option
                                        *ngFor="let option of itemTypeOptions"
                                        [ngValue]="option.value"
                                      >
                                        {{ option.label | translate }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class="mb-4">
                                    <label
                                      class="form-label"
                                      [attr.for]="
                                        'uplifted-item-image-url-' +
                                        i +
                                        '-' +
                                        j +
                                        '-' +
                                        k
                                      "
                                      >{{
                                        'configurationOptionModule.imageUrl'
                                          | translate
                                      }}</label
                                    >

                                    <input
                                      type="text"
                                      class="form-control"
                                      [ngClass]="{
                                        'is-invalid':
                                          item.get('imageUrl')?.invalid &&
                                          (item.get('imageUrl')?.dirty ||
                                            item.get('imageUrl')?.touched)
                                      }"
                                      [attr.aria-invalid]="
                                        item.get('imageUrl')?.invalid &&
                                        (item.get('imageUrl')?.dirty ||
                                          item.get('imageUrl')?.touched)
                                          ? 'true'
                                          : null
                                      "
                                      [attr.id]="
                                        'uplifted-item-image-url-' +
                                        i +
                                        '-' +
                                        j +
                                        '-' +
                                        k
                                      "
                                      formControlName="imageUrl"
                                    />

                                    <p
                                      class="invalid-feedback"
                                      role="alert"
                                      aria-atomic="true"
                                      *ngIf="
                                        item.get('imageUrl')?.invalid &&
                                        (item.get('imageUrl')?.dirty ||
                                          item.get('imageUrl')?.touched)
                                      "
                                    >
                                      <i
                                        role="img"
                                        class="fas fa-exclamation-circle"
                                        aria-hidden="true"
                                      ></i>
                                      {{ 'general.required' | translate }}
                                    </p>
                                  </div>

                                  <div
                                    class="mb-4"
                                    *ngIf="
                                      item.get('type')?.value === itemTypes.TAG
                                    "
                                  >
                                    <label
                                      class="form-label"
                                      [attr.for]="
                                        'uplifted-item-id-' +
                                        i +
                                        '-' +
                                        j +
                                        '-' +
                                        k
                                      "
                                      >{{ 'tagModule.tag' | translate }}</label
                                    >
                                    <ng-select
                                      *ngIf="tags$ | async as tags"
                                      [items]="tags"
                                      [multiple]="false"
                                      [closeOnSelect]="true"
                                      [searchable]="true"
                                      formControlName="id"
                                      bindLabel="description"
                                      bindValue="id"
                                      [labelForId]="
                                        'uplifted-item-id-' +
                                        i +
                                        '-' +
                                        j +
                                        '-' +
                                        k
                                      "
                                      placeholder="{{
                                        'tagModule.selectTag' | translate
                                      }}"
                                      [clearSearchOnAdd]="true"
                                    >
                                    </ng-select>
                                    <p
                                      class="invalid-feedback d-block"
                                      role="alert"
                                      aria-atomic="true"
                                      *ngIf="
                                        item.errors?.itemIdRequired &&
                                        (item.get('id')?.dirty ||
                                          item.get('id')?.touched)
                                      "
                                    >
                                      <i
                                        role="img"
                                        class="fas fa-exclamation-circle"
                                        aria-hidden="true"
                                      ></i>
                                      {{
                                        'configurationOptionModule.discoveryAreaItemIdRequired'
                                          | translate
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-xxl-2">
                                  <div
                                    class="discovery-image-preview-wrapper mx-auto mx-lg-0"
                                    *ngIf="
                                      item.get('imageUrl')?.value as imageUrl
                                    "
                                  >
                                    <img
                                      class="img-thumbnail img-fluid discovery-image-preview"
                                      [src]="imageUrl"
                                      [attr.alt]="'general.image' | translate"
                                      loading="lazy"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                class="row"
                                *ngIf="
                                  item.get('type')?.value === itemTypes.LINK
                                "
                              >
                                <div class="col-lg-6 mb-3">
                                  <label
                                    class="form-label"
                                    [attr.for]="
                                      'uplifted-item-url-' +
                                      i +
                                      '-' +
                                      j +
                                      '-' +
                                      k
                                    "
                                    >{{
                                      'configurationOptionModule.linkUrl'
                                        | translate
                                    }}
                                    <i
                                      class="ms-2 fa fa-question-circle"
                                      role="button"
                                      tabindex="0"
                                      [tooltip]="
                                        'configurationOptionModule.discoveryAreaLinkUrlTooltip'
                                          | translate
                                      "
                                    ></i>
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    [attr.id]="
                                      'uplifted-item-url-' +
                                      i +
                                      '-' +
                                      j +
                                      '-' +
                                      k
                                    "
                                    formControlName="url"
                                  />
                                  <p
                                    class="invalid-feedback d-block"
                                    role="alert"
                                    aria-atomic="true"
                                    *ngIf="
                                      item.errors?.urlRequired &&
                                      (item.get('url')?.dirty ||
                                        item.get('url')?.touched)
                                    "
                                  >
                                    <i
                                      role="img"
                                      class="fas fa-exclamation-circle"
                                      aria-hidden="true"
                                    ></i>
                                    {{
                                      'configurationOptionModule.discoveryAreaLinkUrlRequired'
                                        | translate
                                    }}
                                  </p>
                                </div>
                              </div>
                              <language-inputs
                                *ngIf="
                                  item.get('type')?.value === itemTypes.LINK
                                "
                                [formGroup]="item"
                              ></language-inputs>
                            </div>
                          </div>
                        </ng-container>
                      </div>

                      <div>
                        <button
                          type="button"
                          class="btn btn-soft-primary"
                          (click)="addUpliftedItem(i, j)"
                          [canSee]="editAccessRights"
                        >
                          {{
                            'configurationOptionModule.addUpliftedItem'
                              | translate
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="">
                <button
                  type="button"
                  class="btn btn-soft-primary"
                  (click)="addUpliftedAreaSet(i)"
                  [canSee]="editAccessRights"
                >
                  {{
                    'configurationOptionModule.addUpliftedAreaSets' | translate
                  }}
                </button>
              </div>
            </div>

            <div class="mb-4">
              <h3>
                {{ 'configurationOptionModule.tagGroups' | translate }}
              </h3>
              <div formArrayName="tagGroups">
                <ng-container
                  *ngFor="
                    let tagGroup of getTagGroups(i).controls;
                    let j = index
                  "
                >
                  <div class="card mb-3 discovery-panel" [formGroupName]="j">
                    <div
                      class="card-header discovery-panel-header d-flex align-items-center justify-content-between"
                      [class.is-collapsed]="tagGroupCollapsed[i][j]"
                    >
                      <h4 class="accordion-header">
                        <button
                          type="button"
                          class="accordion-button"
                          [attr.aria-expanded]="
                            tagGroupCollapsed[i][j] ? 'false' : 'true'
                          "
                          (click)="
                            tagGroupCollapsed[i][j] = !tagGroupCollapsed[i][j]
                          "
                          [attr.aria-controls]="'tag-group-' + i + '-' + j"
                        >
                          <span
                            class="d-flex flex-column align-items-start flex-grow-1"
                          >
                            <span class="fs-4">
                              {{
                                tagGroup.get('title_en')?.value ||
                                  ('configurationOptionModule.tagGroup'
                                    | translate)
                              }}
                            </span>
                            <span class="text-small text-body">
                              {{
                                'configurationOptionModule.tagGroup' | translate
                              }}
                              #{{ j + 1 }}
                            </span>
                          </span>
                          <i
                            class="fa fa-fw ms-auto"
                            [ngClass]="
                              tagGroupCollapsed[i][j]
                                ? 'fa-chevron-down'
                                : 'fa-chevron-up'
                            "
                            aria-hidden="true"
                            role="img"
                          ></i>
                        </button>
                      </h4>
                      <button
                        type="button"
                        class="btn btn-ghost-secondary ms-2"
                        (click)="removeTagGroup(i, j)"
                        [canSee]="editAccessRights"
                        [attr.aria-label]="'general.delete' | translate"
                      >
                        <i class="fa fa-trash-alt" aria-hidden="true"></i>
                      </button>
                    </div>

                    <div
                      class="card-body discovery-panel-body"
                      *ngIf="!tagGroupCollapsed[i][j]"
                      [attr.id]="'tag-group-' + i + '-' + j"
                    >
                      <language-inputs [formGroup]="tagGroup"></language-inputs>

                      <div class="mt-3 mb-3">
                        <label
                          class="form-label"
                          [attr.for]="'tag-group-levels-' + i + '-' + j"
                          >{{
                            'configurationOptionModule.levels' | translate
                          }}</label
                        >
                        <ng-select
                          *ngIf="levelOptions$ | async as levelOptions"
                          [items]="levelOptions"
                          [multiple]="true"
                          [closeOnSelect]="false"
                          [searchable]="true"
                          [clearSearchOnAdd]="true"
                          formControlName="levels"
                          bindLabel="label"
                          bindValue="value"
                          [labelForId]="'tag-group-levels-' + i + '-' + j"
                          placeholder="{{ 'general.select' | translate }}"
                        >
                        </ng-select>
                      </div>

                      <div class="mb-3">
                        <label
                          class="form-label"
                          [attr.for]="'target-tag-ids-' + i + '-' + j"
                          >{{ 'tagModule.tags' | translate }}</label
                        >
                        <ng-select
                          *ngIf="tags$ | async as tags"
                          [items]="tags"
                          [multiple]="true"
                          [closeOnSelect]="false"
                          [searchable]="true"
                          formControlName="targetTagIds"
                          bindLabel="description"
                          bindValue="id"
                          [labelForId]="'target-tag-ids-' + i + '-' + j"
                          placeholder="{{ 'tagModule.selectTag' | translate }}"
                          [clearSearchOnAdd]="true"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="">
                <button
                  type="button"
                  class="btn btn-soft-primary"
                  (click)="addTagGroup(i)"
                  [canSee]="editAccessRights"
                >
                  {{ 'configurationOptionModule.addTagGroup' | translate }}
                </button>
              </div>
            </div>
          </div>
        </section>
      </ng-container>
    </div>

    <div class="form-footer justify-content-between sticky-bottom">
      <button
        type="button"
        class="btn btn-soft-primary"
        (click)="addConfig()"
        [disabled]="!canAddConfig()"
        [canSee]="editAccessRights"
      >
        {{ 'configurationOptionModule.addDiscoveryArea' | translate }}
      </button>
      <button
        *ngIf="!!configs.length"
        class="btn btn-primary"
        type="submit"
        [canSee]="editAccessRights"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </div>
</form>
